// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31uWy","label":"styles_label__1x1ei"};